import MessageStrip from "./MessageStrip";
import Header from "./Header";
import TextSlider from "./TextSlider";
import DownloadSection from "./DownloadButtons";
import Footer from "./Footer";

function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <MessageStrip />
      <Header />
      <TextSlider />
      <DownloadSection />
      <div className="flex-grow"></div>
      <Footer />
    </div>
  );
}


export default HomePage;
